import { User, UserDetailedInfo } from "@/types";

import { axios } from "../axios.instance";

export type GoogleAuthRequest = {
  authorizationCode: string;
  role?: User["role"];
  affiliateCode?: string;
};

export type GoogleAuthResponse = {
  user: User & UserDetailedInfo;
  tokens: {
    accessToken: string;
    refreshToken: string;
  };
};

export const googleAuth = async (body: GoogleAuthRequest): Promise<GoogleAuthResponse> => {
  const { data } = await axios.post("auth/socials/google/login", body);

  return data;
};
